import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=b9a5d2a8&scoped=true"
import script from "./PrivacyDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a5d2a8",
  null
  
)

export default component.exports